module.exports = __webpack_public_path__ + "static/assets/a8a9a684b8d35818d0157be0d6910765.png";